export default function selectedRoom(state = false, action) {
  switch (action.type) {
    case 'select_room': 
      return action.item;
    default:
      return state;
  }
}